module.exports = __webpack_public_path__ + "images/emoji/bike.bb4f3a0c67a1035d32cf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bike.png
// module id = LCOq
// module chunks = 13